// extracted by mini-css-extract-plugin
export default {"c-invite__test-instructions":"TestInstructions_c-invite__test-instructions__cKB-H"};